import React, { Dispatch, SetStateAction } from 'react';
import { Tournaments } from '../../../../pages/tournamentsPage/tournamentsPage';
import { t } from '../../../../utils/helpers';
import { AdditionalType, Tourney } from '../../model/interfaces';
import {
  startIn,
  months,
} from '../tournamentsAdditionalInfo/tournamentsAdditionalInfo';
import { TournamentConnectButton } from './inProgressTournamentButtonConnect/inProgressTournamentButtonConnect';

export const InProgressTournaments = (props: {
  tournaments: Tournaments | null;
  setComponent: Dispatch<SetStateAction<AdditionalType | undefined>>;
}) => {
  const progressTournaments = props.tournaments?.started;

  function handlerShowAdditional(data: AdditionalType) {
    props.setComponent(data);
  }

  function renderPendingList(tournaments: Tourney[]) {
    return tournaments.map((tournament) => {
      const { TourneyID, StartTimeUTC, Name, DirectorName, EntryFee } = tournament;
      const time = startIn(StartTimeUTC.toString());
      const minutes =
        new Date(time).getMinutes() < 10
          ? `${new Date(time).getMinutes()}0`
          : new Date(time).getMinutes();
      const timeStart = `${months[new Date(time).getMonth()]} ${new Date(
        time
      ).getDate()}, ${new Date(time).getHours()}:${minutes}`;

      const addData: AdditionalType = {
        tourneyID: tournament.TourneyID,
        component: 'inProgress',
        directorName: tournament.DirectorName,
        directorId: tournament.Director,
        startTime: timeStart,
        checkIn: '5min prior to start',
        pairing: tournament.PairingType,
        timeControl: tournament.TimeControl,
        entryFee: tournament.EntryFee,
        description: tournament.Description,
        extraBonus: tournament.ExtraBonus,
        firstPrizeUsr: tournament.FirstPrizeUsr,
        firstPrizeAmt: tournament.FirstPrizeAmt,
        secondPrizeUsr: tournament.SecondPrizeUsr,
        secondPrizeAmt: tournament.SecondPrizeAmt,
        thirdPrizeUsr: tournament.ThirdPrizeUsr,
        thirdPrizeAmt: tournament.ThirdPrizeAmt,
        fourthPrizeUsr: tournament.FourthPrizeUsr,
        fourthPrizeAmt: tournament.FourthPrizeAmt,
      };

      return (
        <div
          className="progress__content"
          key={TourneyID}
          onClick={() => {
            handlerShowAdditional(addData);
          }}
        >
          <div className="tournaments__item-title">{timeStart}</div>
          <div className="tournaments__item-rules">{Name}</div>
          <div className="tournaments__item-director">
            <div className="avatar-overlay">
              <img
                className="avatar"
                src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${tournament.Director}&size=2`}
                alt="avatar"
              />
            </div>
            <div className="tournaments__item-director-name">
              {DirectorName}
            </div>
          </div>
          <div className="tournaments__item-entry">{`${EntryFee} Tickets`}</div>
          {tournament.Host &&
            tournament.Port && 
            tournament.wssproxy && (
              <TournamentConnectButton
                host={tournament.Host}
                port={tournament.Port}
                proxy={tournament.wssproxy}
                tourneyID={tournament.TourneyID}
              />
            )}
        </div>
      );
    });
  }

  const pendingListJSX =
    progressTournaments &&
    !!progressTournaments.length &&
    renderPendingList(progressTournaments);

  return (
    <>
      <div className="tournaments__item-header progress__header">
        <div className="progress__header-title">{t('started')}</div>
        <div className="progress__header-rules">{`${t('tournament')} / ${t(
          'rules'
        )}`}</div>
        <div className="progress__header-director">{t('director')}</div>
        <div className="progress__header-entry">{t('entry_fee')}</div>
        <div className="progress__header-time-start">
          {t('tournament_room')}
        </div>
      </div>
      <div className="tournaments__item-content">{pendingListJSX}</div>
    </>
  );
};
